import { createBulkMutationHook, createDefaultMutationHook } from "hooks/useMutationHandler";

import { USER_ROLE_BINDING_DELETE } from "./gql";

export const useBulkUserRoleDelete = createBulkMutationHook(USER_ROLE_BINDING_DELETE);

const useUserRoleDelete = createDefaultMutationHook(USER_ROLE_BINDING_DELETE);
export default useUserRoleDelete;
